export default "__VITE_ASSET__BNtc1xu4__"